
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ReCaptchaV3 from "Components/Elements/ReCaptcha/ReCaptchaV3";
import { configure } from "mobx";

configure({
    enforceActions: "never", // Options: "always", "observed", or "never"
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ReCaptchaV3>
        <App />
    </ReCaptchaV3>
);